import { render, staticRenderFns } from "./BookingIndex.vue?vue&type=template&id=07b843b8&scoped=true&"
import script from "./BookingIndex.vue?vue&type=script&lang=js&"
export * from "./BookingIndex.vue?vue&type=script&lang=js&"
import style0 from "./BookingIndex.vue?vue&type=style&index=0&id=07b843b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b843b8",
  null
  
)

export default component.exports